import { render, staticRenderFns } from "./LiveShareRecord.vue?vue&type=template&id=5ab2bc63&scoped=true"
import script from "./LiveShareRecord.vue?vue&type=script&lang=js"
export * from "./LiveShareRecord.vue?vue&type=script&lang=js"
import style0 from "./LiveShareRecord.vue?vue&type=style&index=0&id=5ab2bc63&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab2bc63",
  null
  
)

export default component.exports